export default "__VITE_ASSET__DOpNqVBG__"